SCASLSetting = {
    "apikey": "AIzaSyARtQhJkmnKptIH8IrT5RyOw2QIObJb1lo",
    "radius": ["10", "20", "30", "40"],
    "df_radius": 0,
    "df_measurement": "km",
    "selected_tags": [],
    "selected_wfields": ["title", "description", "phone", "email", "fax", "web", "tags", "schedule", "store_image", "address", "country", "state", "city", "zipcode"],
    "wstyle": "#scasl-window-container #scasl-title{display:block !important}\n#scasl-window-container #scasl-description{display:block !important}\n#scasl-window-container #scasl-phone{display:block !important}\n#scasl-window-container #scasl-email{display:block !important}\n#scasl-window-container #scasl-fax{display:block !important}\n#scasl-window-container #scasl-web{display:block !important}\n#scasl-window-container #scasl-tags{display:block !important}\n#scasl-window-container #scasl-schedule{display:block !important}\n#scasl-window-container #scasl-store_image{display:block !important}\n#scasl-window-container #scasl-address{display:block !important}\n#scasl-window-container #scasl-country{display:inline-block !important}\n#scasl-window-container #scasl-state{display:inline-block !important}\n#scasl-window-container #scasl-city{display:inline-block !important}\n#scasl-window-container #scasl-zipcode{display:inline-block !important}\n",
    "selected_lfields": ["title", "store_image", "address", "country", "state", "city", "zipcode", "distance", "direction"],
    "lstyle": "#scasl-list-container #scasl-title{display:block !important}\n#scasl-list-container #scasl-store_image{display:block !important}\n#scasl-list-container #scasl-address{display:block !important}\n#scasl-list-container #scasl-country{display:inline-block !important}\n#scasl-list-container #scasl-state{display:inline-block !important}\n#scasl-list-container #scasl-city{display:inline-block !important}\n#scasl-list-container #scasl-zipcode{display:inline-block !important}\n#scasl-list-container #scasl-distance{display:block !important}\n#scasl-list-container #scasl-direction{display:block !important}\n",
    "zoom": 12,
    "extrafield": "",
    "status": 1,
    "autogeocode": 1,
    "alltags": 1,
    "search_bg_color": "#ffffff",
    "search_border_color": "#cccccc",
    "search_border_size": 1,
    "loc_btn_color": "#e4a3a7",
    "search_btn_color": "#e4a3a7",
    "map_border_color": "#cccccc",
    "map_border_size": 1,
    "map_bg_color": "#ffffff",
    "info_border_color": "#cccccc",
    "info_border_size": 1,
    "info_bg_color": "#ffffff",
    "info_shop_name_color": "#000000",
    "info_shop_info_color": "#555555",
    "info_shop_info_font": "",
    "info_shop_name_font": "",
    "search_font": "",
    "page_title": "Find Our Stores",
    "curr_loc_text": "Current Location",
    "radius_text": "Search Radius",
    "msr_text": "Search Radius Measurement",
    "find_loc_btn_text": "Find My Location",
    "search_btn_text": "Search",
    "filter_tags_text": "Filter Tags",
    "enter_a_location_text": "Enter a location",
    "add_error_alert": "Unable to find address",
    "distance_error_alert": "Unfortunately, our closest location is more than",
    "no_result_title": "No results",
    "no_result_tags": "No locations were found with the given tags. Please modify your selections or input.",
    "max_results": 100,
    "scasl_phone_label": "",
    "scasl_fax_label": "",
    "scasl_email_label": "",
    "scasl_schedule_label": "",
    "map_style_name": "default",
    "map_style_data": "",
    "no_result_go_to_home_page": "Go to home page",
    "default_view": 0,
    "default_latitude": "-37.974944",
    "default_longitude": "145.082927",
    "filter_tags_by": "and",
    "default_view_zoom": 12,
    "restric_country": [],
    "restric_country_text": "",
    "miles_text": "miles",
    "kilometers_text": "kilometers",
    "cluster": 0,
    "max_result_in_first_loading": 5000,
    "no_limit_text": "No Limit",
    "query_url": 0,
    "clusters_style": "default",
    "clustering_custom": "{\"cluster_color_level_1\":\"#ffffff\",\"cluster_image_level_1\":\"https:\\\/\\\/developers.google.com\\\/maps\\\/documentation\\\/javascript\\\/examples\\\/markerclusterer\\\/m1.png\",\"cluster_color_level_2\":\"#ffffff\",\"cluster_image_level_2\":\"https:\\\/\\\/developers.google.com\\\/maps\\\/documentation\\\/javascript\\\/examples\\\/markerclusterer\\\/m2.png\",\"cluster_color_level_3\":\"#ffffff\",\"cluster_image_level_3\":\"https:\\\/\\\/developers.google.com\\\/maps\\\/documentation\\\/javascript\\\/examples\\\/markerclusterer\\\/m3.png\",\"cluster_color_level_4\":\"#ffffff\",\"cluster_image_level_4\":\"https:\\\/\\\/developers.google.com\\\/maps\\\/documentation\\\/javascript\\\/examples\\\/markerclusterer\\\/m4.png\",\"cluster_color_level_5\":\"#ffffff\",\"cluster_image_level_5\":\"https:\\\/\\\/developers.google.com\\\/maps\\\/documentation\\\/javascript\\\/examples\\\/markerclusterer\\\/m5.png\"}",
    "no_result_url": "",
    "autocomplete_option": "address",
    "store_sort": "default",
    "created_at": "2017-08-24T05:29:21.000000Z",
    "dynamic_view": 0,
    "dynamic_view_realtime": 0,
    "pegman": 1,
    "map_satellite_option": 1,
    "zoom_control": 1,
    "restricted_map_view": 0,
    "display_operating_hours": 0,
    "operating_hours": null,
    "date_overrides": null,
    "location_is_disabled_alert": "",
    "location_is_disabled_text": "",
    "kilometer_unit_text": "",
    "meter_unit_text": "",
    "more_text": "",
    "less_text": "",
    "list_text": "",
    "map_text": "",
    "direction_text": "",
    "image_position": "beside",
    "image_size": "medium",
    "open_text": "",
    "opens_text": "",
    "open_now_text": "",
    "closed_text": "",
    "closes_text": "",
    "closes_soon_text": "",
    "monday_text": "",
    "tuesday_text": "",
    "wednesday_text": "",
    "thursday_text": "",
    "friday_text": "",
    "saturday_text": "",
    "sunday_text": "",
    "hours_might_differ": "",
    "monday_acronym_text": "",
    "tuesday_acronym_text": "",
    "wednesday_acronym_text": "",
    "thursday_acronym_text": "",
    "friday_acronym_text": "",
    "saturday_acronym_text": "",
    "sunday_acronym_text": "",
    "address_icon": null,
    "phone_icon": null,
    "email_icon": null,
    "fax_icon": null,
    "web_url_icon": null,
    "oh_icon": null,
    "icon_color": "#0000FF",
    "def_apk": "AIzaSyBbuIsXyK7qlI5PsMv2nRYObu1eno846tU",
    "locationsRaw": JSON.stringify(window.storeLocatorData), 
    "origin_marker_img": "https:\/\/cdn.shopify.com\/s\/files\/1\/1200\/4142\/t\/63\/assets\/sca.location-origin-marker.png?v=1666499734",
    "arrow_up": "https:\/\/cdn.shopify.com\/s\/files\/1\/1200\/4142\/t\/63\/assets\/sca.location-arrow-up.png?v=1686192670",
    "arrow_down": "https:\/\/cdn.shopify.com\/s\/files\/1\/1200\/4142\/t\/63\/assets\/sca.location-arrow-down.png?v=1686192672",
    "loading": "https:\/\/cdn.shopify.com\/s\/files\/1\/1200\/4142\/t\/63\/assets\/sca.location-loading.png?v=1686192673",
    "display_timezone": 1,
    "time_format": 0,
    "timezone": "",
    "app_url": "https:\/\/storelocator.amai.com",
    "cdn_app_url": "https:\/\/prana-chai-dev.myshopify.com",
    "suffix_url": null,
    "is_normal": true,
    "release_api_key_date": "2023-12-15"
};
/*! General Script Store Locator - v1.2.2 - 2023-12-22 */
var hasOriginSL = !1,
    locatorElems = document.querySelectorAll("#avt-app-container"),
    currentUrl = window.location.href,
    currentUrlSuffix = currentUrl.split("/").pop();
const SCASLDefaultSuffix = "store-locator";
1 == locatorElems.length && "undefined" == typeof isLocatorAppBlock && "undefined" == typeof isLocatorAppEmbed && (hasOriginSL = !0), 1 == locatorElems.length && "undefined" != typeof isLocatorAppEmbed && ("store-locator" == currentUrlSuffix && !SCASLSetting.suffix_url || SCASLSetting.suffix_url && currentUrlSuffix == SCASLSetting.suffix_url) && (hasOriginSL = !0), locatorElems.length > 1 && ("undefined" != typeof isLocatorAppBlock || "undefined" != typeof isLocatorAppEmbed) && (hasOriginSL = !0);
var hasQueryString = currentUrl.includes("bh-sl-address");
const SCASLUrlParams = new URLSearchParams(window.location.search);
var isPreview = !!SCASLUrlParams.get("oseid");
! function() {
    if (SCASLSetting.status && (isPreview || currentUrlSuffix == SCASLSetting.suffix_url || hasOriginSL || hasQueryString || "undefined" != typeof isLocatorAppBlock) && document.getElementById("avt-app-container")) {
        const u = SCASLSetting.zoom;
        for (var t, e = function() {}, o = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "table", "time", "timeEnd", "timeStamp", "trace", "warn"], i = o.length, n = window.console = window.console || {}; i--;) n[t = o[i]] || (n[t] = e);
        var a = "scasl-tag-list-container",
            r = "scasl-lengthUnit",
            l = "scasl-radius-container",
            s = function(t, e) {
                var o = document.createElement("script");
                o.type = "text/javascript", o.readyState ? o.onreadystatechange = function() {
                    "loaded" != o.readyState && "complete" != o.readyState || (o.onreadystatechange = null, e())
                } : o.onload = function() {
                    e()
                }, o.src = t, document.getElementsByTagName("head")[0].appendChild(o)
            },
            c = function(t, e) {
                if ("js" == e)(o = document.createElement("script")).setAttribute("type", "text/javascript"), o.setAttribute("src", t);
                else if ("css" == e) {
                    var o;
                    (o = document.createElement("link")).setAttribute("rel", "stylesheet"), o.setAttribute("type", "text/css"), o.setAttribute("href", t)
                }
                void 0 !== o && document.getElementsByTagName("head")[0].appendChild(o)
            };

        function S(t) {
            var e = !0,
                o = !1,
                i = !1;
            1 == SCASLSetting.default_view && (e = !1), 1 == SCASLSetting.autogeocode && (i = !0), 1 == SCASLSetting.query_url && void 0 !== function(t) {
                var e, o, i = decodeURIComponent(window.location.search.substring(1)).split("&");
                for (o = 0; o < i.length; o++)
                    if ((e = i[o].split("="))[0] === t) return void 0 === e[1] || e[1]
            }("bh-sl-address") && (o = !0, e = !0, i = !1);
            var n = {
                autoComplete: !0,
                dataType: "json",
                maxDistance: !0,
                maxDistanceID: l,
                lengthUnitID: r,
                taxonomyFilters: {
                    tagsvalue: a
                },
                listTemplateID: "scasl-list-template",
                infowindowTemplateID: "scasl-infowindow-template",
                disableAlphaMarkers: !0,
                mapSettings: {
                    zoom: SCASLSetting.zoom,
                    mapId: 'prana-store-locator',
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    zoomControl: SCASLSetting.zoom_control,
                    streetViewControl: SCASLSetting.pegman,
                    mapTypeControl: SCASLSetting.map_satellite_option
                },
                fullMapStart: e,
                geocodeID: "scapl-geocode-btn:visible",
                autoGeocode: i,
                querystringParams: o,
                originMarkerImg: SCASLSetting.origin_marker_img ? SCASLSetting.origin_marker_img : "undefined" != typeof isLocatorAppEmbed || "undefined" != typeof isLocatorAppBlock ? originMarkerImg : ""
            };
            if ("default" != SCASLSetting.map_style_name && (n.mapSettings.styles = SCASLSetting.map_style_data), SCASLSetting.locationsRaw ? (n.dataRaw = SCASLSetting.locationsRaw, "[]" == SCASLSetting.locationsRaw && 1 != SCASLSetting.default_view && setTimeout((function() {
                    t("#bh-sl-map-container").hide(), t(".spinner").hide()
                }), 1500)) : n.dataLocation = SCASLSetting.locationsUrl, SCASLSetting.kilometers_text && (n.kilometerLang = SCASLSetting.kilometers_text, n.kilometersLang = SCASLSetting.kilometers_text), SCASLSetting.miles_text && (n.mileLang = SCASLSetting.miles_text, n.milesLang = SCASLSetting.miles_text), 1 == SCASLSetting.cluster)
                if ("custom" == SCASLSetting.clusters_style) {
                    var s = t.parseJSON(SCASLSetting.clustering_custom);
                    n.markerCluster = {
                        styles: [{
                            textColor: s.cluster_color_level_1,
                            url: s.cluster_image_level_1,
                            height: 52,
                            width: 53
                        }, {
                            textColor: s.cluster_color_level_2,
                            url: s.cluster_image_level_2,
                            height: 55,
                            width: 56
                        }, {
                            textColor: s.cluster_color_level_3,
                            url: s.cluster_image_level_3,
                            height: 65,
                            width: 66
                        }, {
                            textColor: s.cluster_color_level_4,
                            url: s.cluster_image_level_4,
                            height: 77,
                            width: 78
                        }, {
                            textColor: s.cluster_color_level_5,
                            url: s.cluster_image_level_5,
                            height: 89,
                            width: 90
                        }]
                    }
                } else n.markerCluster = {
                    imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
                };
            return m() && (n.autoGeocode = !1), n.storeLimit = parseInt(SCASLSetting.max_results) || 26, n.addressErrorAlert = SCASLSetting.add_error_alert, n.distanceErrorAlert = SCASLSetting.distance_error_alert, n.noResultsTitle = SCASLSetting.no_result_title, n.noResultsDesc = SCASLSetting.no_result_tags, n.noResultsGoToHomePage = SCASLSetting.no_result_go_to_home_page, "" != SCASLSetting.no_result_url && (n.noResultsURL = SCASLSetting.no_result_url), 1 == SCASLSetting.default_view && (n.defaultLoc = !0), n.defaultLat = SCASLSetting.default_latitude, n.defaultLng = SCASLSetting.default_longitude, "#ffffff" == SCASLSetting.info_bg_color && "#cccccc" == SCASLSetting.info_border_color || (n.infoBubble = {
                backgroundClassName: "scasl-store-info-window",
                backgroundColor: SCASLSetting.info_bg_color,
                maxWidth: 350,
                minWidth: 270,
                maxHeight: 400,
                closeSrc: SCASLSetting.cdn_app_url + "/assets/cdn/img/close-icon-dark.png",
                borderRadius: 0
            }), "or" == SCASLSetting.filter_tags_by && (n.exclusiveFiltering = !0), "regions" == SCASLSetting.autocomplete_option && (n.autoCompleteOptions = {
                types: ["(regions)"]
            }), n.callbackListClick = p, n
        }
        c("//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.5/handlebars.min.js", "js"), c("//cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js", "js");
        var p = function() {
            SCASLSetting.zoom = u
        };

        function m() {
            var t, e = !1;
            try {
                t = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0)
            } catch (t) {
                n.log(t)
            }
            return e
        }
        var d = function(t) {
            var e = SCASLSetting.wstyle + SCASLSetting.lstyle;
            if (e && function(t) {
                    var e = document.head || document.getElementsByTagName("head")[0],
                        o = document.createElement("style");
                    o.type = "text/css", o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(document.createTextNode(t)), e.appendChild(o)
                }(e), function(t) {
                    var e = t("#" + l);
                    if (0 == SCASLSetting.radius.length) e.parent().hide();
                    else {
                        for (var o = 0; o < SCASLSetting.radius.length; ++o) {
                            var i = parseInt(SCASLSetting.radius[o].trim()) || 0;
                            i && e.append('<option value="' + i + '" ' + (SCASLSetting.df_radius == i ? " selected='selected'" : " ") + ">" + i + "</option>")
                        }
                        e.append('<option value="0"' + (0 == SCASLSetting.df_radius ? " selected='selected'" : " ") + ">" + SCASLSetting.no_limit_text + "</option>")
                    }
                    t("#" + r).val(SCASLSetting.df_measurement)
                }(t), function(t) {
                    var e = t("#" + a);
                    if (0 == SCASLSetting.selected_tags.length) e.parent().hide();
                    else
                        for (var o = 0; o < SCASLSetting.selected_tags.length; ++o) e.append('<li> <label> <input type="checkbox" name="tagsvalue" value="' + SCASLSetting.selected_tags[o] + '"> ' + SCASLSetting.selected_tags[o] + " </label> </li>")
                }(t), function(t) {
                    if (t(".bh-sl-title").html(SCASLSetting.page_title), t('#avt-app-container label[for="bh-sl-address"]').html(SCASLSetting.curr_loc_text), t('#avt-app-container label[for="scasl-radius-container"]').html(SCASLSetting.radius_text), t('#avt-app-container label[for="scasl-lengthUnit"]').html(SCASLSetting.msr_text), t('#avt-app-container label[for="scasl-tag-list-container"]').html(SCASLSetting.filter_tags_text), t("#avt-app-container button#scapl-geocode-btn").html(SCASLSetting.find_loc_btn_text), t("#avt-app-container #bh-sl-submit").html(SCASLSetting.search_btn_text), SCASLSetting.kilometer_unit_text && t('#scasl-lengthUnit option[value="km"]').html(SCASLSetting.kilometer_unit_text), SCASLSetting.meter_unit_text && t('#scasl-lengthUnit option[value="m"]').html(SCASLSetting.meter_unit_text), SCASLSetting.more_text && t(".scasl-see-more").html(SCASLSetting.more_text + " &raquo;"), SCASLSetting.less_text && t(".scasl-see-less").html(SCASLSetting.less_text + " &laquo;"), SCASLSetting.list_text && t(".scasl-tab-list").html(SCASLSetting.list_text), SCASLSetting.map_text && t(".scasl-tab-map").html(SCASLSetting.map_text), void 0 !== SCASLSetting.enter_a_location_text) {
                        let e = t("#bh-sl-address").attr("placeholder");
                        e = e || SCASLSetting.enter_a_location_text, t("#bh-sl-address").attr("placeholder", e)
                    }
                }(t), function(t) {
                    var e = "",
                        o = "",
                        i = t("<style>" + o + e + "</style>");
                    t("html > head").append(i)
                }(t), function(t) {
                    var e = "";
                    t("html > head").append(e), t("#bh-sl-map").attr("style", "border-color:" + SCASLSetting.map_border_color + ";border-width:" + SCASLSetting.map_border_size + "px !important")
                }(t), t(".bh-sl-form-container").show(), t("#bh-sl-map-container").storeLocator(S(t)), function(t) {
                    m() && t(".scasl-location-mobile-wrap").length > 0 && (t(".bh-sl-form-container").hide(), t(".scasl-location-mobile-wrap").show(), t(".scasl-location-mobile-wrap").click((function() {
                        t(".bh-sl-form-container").is(":visible") ? t(".bh-sl-form-container").hide(1e3) : t(".bh-sl-form-container").show(1e3)
                    })))
                }(t), t(".new-for-mobile").length > 0 && function(t) {
                    var e = t("#scasl-viewmap-btn-template").html();
                    t(".new-for-mobile .scasl-see-more").click((function() {
                        var e = t(this);
                        return t(".new-for-mobile .scasl-see-more-content").slideDown("slow", (function() {
                            e.hide(), t(".new-for-mobile .scasl-see-less").show()
                        })), !1
                    })), t(".new-for-mobile .scasl-see-less").click((function() {
                        var e = t(this);
                        return t(".new-for-mobile .scasl-see-more-content").slideUp("slow", (function() {
                            e.hide(), t(".new-for-mobile .scasl-see-more").show()
                        })), !1
                    })), t(".new-for-mobile .scasl-tab-list").click((function() {
                        t(this).addClass("active"), t(".new-for-mobile #scasl-tabs li.scasl-tab-map").removeClass("active"), t(".new-for-mobile .bh-sl-loc-list").show(), t(".new-for-mobile #bh-sl-map").hide()
                    })), t(".new-for-mobile .scasl-tab-map").click((function() {
                        t(this).addClass("active"), t(".new-for-mobile #scasl-tabs li.scasl-tab-list").removeClass("active"), t(".new-for-mobile .bh-sl-loc-list").hide(), t(".new-for-mobile #bh-sl-map").show()
                    })), m() && (t(document).on("click", ".new-for-mobile .scasl-location-list ul.list > li", (function() {
                        t(".new-for-mobile .scasl-view-map-btn").remove();
                        var o = Handlebars.compile(e);
                        t(this).after(o)
                    })), t(document).on("click", ".new-for-mobile .scasl-view-map-btn", (function() {
                        t(".new-for-mobile .scasl-tab-map").trigger("click")
                    })))
                }(t), "function" == typeof scaStoreLocatorCallback) try {
                scaStoreLocatorCallback()
            } catch (t) {
                n.log("Callback Error!"), n.log(t)
            }
        };

        function g() {
            if (function(t) {
                    var e = t("#MainContent #avt-app-container"),
                        o = t(".shopify-app-block #locator-app-block").parent(),
                        i = t(".shopify-app-block #locator-app-embed").parent(),
                        n = t(".shopify-section"),
                        a = null;
                    n.each((function(e, o) {
                        var i = t(this).find("#avt-app-container");
                        if (i.length && "locator-app-block" != i.parent().attr("id") && "locator-app-embed" != i.parent().attr("id")) return a = t(this), !1
                    })), o.length ? (i.length && i.remove(), o.first().parent().removeClass("page-width"), o.length > 1 && o.not(":first").remove(), a && a.remove(), t("#locator-app-block").show()) : i.length && (a && a.remove(), t("#MainContent").prepend(i), t("h1.main-page-title").parent().parent().hide(), t(".section-header h1").parent().parent().parent().parent().hide(), (!isPreview || isPreview && currentUrl.includes("pages/" + SCASLSetting.suffix_url)) && t("#locator-app-embed").show());
                    "undefined" == typeof isLocatorAppBlock && "undefined" == typeof isLocatorAppEmbed || 1 == e.length && "locator-app-block" != e.parent().attr("id") && "locator-app-embed" != e.parent().attr("id") && e.remove()
                }(jQuerySCASL), 0 == jQuerySCASL("#avt-app-container").length) return !1;
            c(window.storelocatorcss, "css"), n.log("loadding locator plugin..."), s("//maps.google.com/maps/api/js?key=" + function() {
                var t = "";
                if (SCASLSetting.apikey) t = SCASLSetting.apikey;
                else {
                    var e = SCASLSetting.is_normal ? new Date(SCASLSetting.created_at) : new Date(SCASLSetting.release_api_key_date),
                        o = new Date;
                    if (new Date(o - e) / 1e3 / 60 / 60 / 24 > 6) return "";
                    t = SCASLSetting.def_apk
                }
                return t.trim()
            }() + "&libraries=places", (function() {
                s(window.storelocatorjs, (function() {
                    jQuerySCASL(document).ready((function() {
                        d(jQuerySCASL)
                    }))
                }))
            })), n.log("finished!")
        }
        "undefined" == typeof jQuery || function(t, e) {
            try {
                var o = t.split("."),
                    i = e.split("."),
                    a = 1e8 * parseInt(o[0]) + 1e6 * parseInt(o[1]) + 1e4 * parseInt(o[2]),
                    r = 1e8 * parseInt(i[0]) + 1e6 * parseInt(i[1]) + 1e4 * parseInt(i[2]);
                return a > r ? 1 : a < r ? -1 : 0
            } catch (t) {
                n.log(t)
            }
            return 1
        }("3.0.0", jQuery.fn.jquery) > 0 ? s("//ajax.googleapis.com/ajax/libs/jquery/3.0.0/jquery.min.js", (function() {
            n.log("finished load jquery.."), jQuerySCASL = jQuery.noConflict(!0), g()
        })) : (n.log("use shop's jquery.."), jQuerySCASL = jQuery, g())
    }
}();